import { render } from "./MainDataTableComponent.vue?vue&type=template&id=1490dee6&scoped=true"
import script from "./MainDataTableComponent.vue?vue&type=script&lang=js"
export * from "./MainDataTableComponent.vue?vue&type=script&lang=js"

import "./MainDataTableComponent.vue?vue&type=style&index=0&id=1490dee6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1490dee6"]])

export default __exports__